module.exports = __webpack_public_path__ + "img/penguin.f0d5d9ea.png";